// //Lottie animation in hero
//
// // Logo animation
// const lottieAnimations = document.querySelectorAll(".lottie-animation");
//
//
// function initLottie() {
//     if (lottieAnimations) {
//         lottieAnimations.forEach((lottieContainer) => {
//             let playing = 1;
//             let lottieSrc = lottieContainer.getAttribute('data-animation'); // data-animation has lottie url
//
//             let animation = lottie.loadAnimation({
//                 container: lottieContainer,
//                 renderer: 'svg',
//                 autoplay: true,
//                 loop: true,
//                 path: lottieSrc,
//
//             });
//
//             // Pause/play animation toggle via click
//             lottieContainer.addEventListener('click', () => {
//                 if (playing===1) {
//                     animation.pause();
//                     playing=0;
//                     lottieContainer.classList.add('paused');
//                 }
//                 else {
//                     animation.play();
//                     playing=1;
//                     lottieContainer.classList.remove('paused');
//                 }
//             });
//             // if (heroLottie) {
//             //     const animation = lottie.loadAnimation({
//             //         container: document.getElementById('logo-animation'),
//             //         renderer: 'svg',
//             //         autoplay: false,
//             //         loop: false,
//             //         path: 'wp-content/themes/one-mayfair/assets/lottie/logo-animation.json',
//             //
//             //     });
//             // }
//         });
//     }
// }
//
//
// const aniPath = 'wp-content/themes/anything-but-ordinary/assets/lottie';
// // Logo animation
// const animationMobileSm = lottie.loadAnimation({
//     container: document.getElementById('res-mobile-sm'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_375x667.json',
//
// });
//
// const animationMobileMed = lottie.loadAnimation({
//     container: document.getElementById('res-mobile-med'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_450x800.json',
//
// });
//
// const animationMobileLrg = lottie.loadAnimation({
//     container: document.getElementById('res-mobile-lrg'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_576x1025.json',
//
// });
//
//
//
// const animation1140 = lottie.loadAnimation({
//     container: document.getElementById('res-1140'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_1140x3440.json',
//
// });
//
// const animation1152 = lottie.loadAnimation({
//     container: document.getElementById('res-1152'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_1152x648.json',
//
// });
//
// const animation1230 = lottie.loadAnimation({
//     container: document.getElementById('res-1230'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_1230x768.json',
//
// });
//
// const animation1640 = lottie.loadAnimation({
//     container: document.getElementById('res-1640'),
//     renderer: 'svg',
//     // autoplay: true,
//     // loop: true,
//     path: aniPath+'/AlfredWalking_1640x922.json',
//
// });
//
//
//
// const animation1080p = lottie.loadAnimation({
//     container: document.getElementById('res-1080'),
//     renderer: 'svg',
//     autoplay: true,
//     loop: true,
//     path: aniPath+'/AlfredWalking_1920x1080.json',
//
// });
//
// const animation2304 = lottie.loadAnimation({
//     container: document.getElementById('res-2304'),
//     renderer: 'svg',
//     autoplay: true,
//     loop: true,
//     path: aniPath+'/AlfredWalking_2304x1296.json',
//
// });
//
//
// const animation1440p = lottie.loadAnimation({
//     container: document.getElementById('res-1440'),
//     renderer: 'svg',
//     autoplay: true,
//     loop: true,
//     path: aniPath+'/AlfredWalking_2560x1440.json',
//
// });
//
// const animationUW = lottie.loadAnimation({
//     container: document.getElementById('res-ultrawide'),
//     renderer: 'svg',
//     autoplay: true,
//     loop: true,
//     path: aniPath+'/AlfredWalking_3440x1140.json',
//
//
// });
//
//
//
// // document.addEventListener("DOMContentLoaded", function() {
// //     initLottie();
// // });



//Lottie animation in hero

// Logo animation
const lottieAnimations = document.querySelectorAll(".lottie-animation");


function initLottie() {
    if (lottieAnimations) {
        lottieAnimations.forEach((lottieContainer) => {
            let playing = 1;
            let lottieSrc = lottieContainer.getAttribute('data-lottie'); // data-animation has lottie url

            let animation = lottie.loadAnimation({
                container: lottieContainer,
                // renderer: 'svg',
                render: 'canvas',
                autoplay: true,
                loop: true,
                path: lottieSrc,
                //fit animation to canvas without cropping or scaling
                // rendererSettings: {
                //     preserveAspectRatio: 'xMidYMid slice'
                // }

            });

            // Pause/play animation toggle via click
            lottieContainer.addEventListener('click', () => {
                if (playing===1) {
                    animation.pause();
                    playing=0;
                    lottieContainer.classList.add('paused');
                }
                else {
                    animation.play();
                    playing=1;
                    lottieContainer.classList.remove('paused');
                }
            });
            // if (heroLottie) {
            //     const animation = lottie.loadAnimation({
            //         container: document.getElementById('logo-animation'),
            //         renderer: 'svg',
            //         autoplay: false,
            //         loop: false,
            //         path: 'wp-content/themes/one-mayfair/assets/lottie/logo-animation.json',
            //
            //     });
            // }
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {

    // if (lottieAnimations) {
        initLottie();
    // }
});
